import React from 'react';
import { 
  Grid, 
  Card, 
  CardContent, 
  Typography, 
  Button,
  Box,
  Chip
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import {
  Receipt as ReceiptIcon,
  Assessment as AssessmentIcon,
  People as PeopleIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';

function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const quickActions = [
    { 
      label: 'Transactions', 
      icon: <ReceiptIcon />, 
      path: '/transactions',
      requiredPermission: 'transactions:read',
      color: '#1976d2'
    },
    { 
      label: 'Reports', 
      icon: <AssessmentIcon />, 
      path: '/reports',
      requiredPermission: 'reports:read',
      color: '#2e7d32'
    },
    { 
      label: 'User Management', 
      icon: <PeopleIcon />, 
      path: '/users',
      requiredPermission: 'users:read',
      color: '#ed6c02'
    },
    { 
      label: 'Settings', 
      icon: <SettingsIcon />, 
      path: '/settings',
      requiredPermission: 'settings:read',
      color: '#9c27b0'
    },
  ];

  const hasPermission = (permission) => {
    const [resource, action] = permission.split(':');
    return user?.permissions[resource]?.includes(action) || false;
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div>
      {/* Welcome Section */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <div>
          <Typography variant="h4" gutterBottom>
            Welcome to Artha Bhaskar!
          </Typography>
          <Typography variant="body1" color="textSecondary">
            You are logged in as: {user?.name}
          </Typography>
        </div>
        <Box display="flex" alignItems="center" gap={2}>
          <Chip 
            label={user?.role} 
            color="primary" 
            variant="outlined" 
          />
          <Button 
            variant="outlined" 
            color="secondary" 
            onClick={logout}
          >
            Logout
          </Button>
        </Box>
      </Box>

      {/* Quick Actions */}
      <Typography variant="h5" gutterBottom style={{ marginBottom: '20px' }}>
        Quick Actions
      </Typography>
      
      <Grid container spacing={3}>
        {quickActions.map((action) => {
          const hasAccess = hasPermission(action.requiredPermission);
          
          return (
            <Grid item xs={12} sm={6} md={3} key={action.label}>
              <Card 
                style={{ 
                  opacity: hasAccess ? 1 : 0.5,
                  height: '140px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  cursor: hasAccess ? 'pointer' : 'not-allowed'
                }}
                onClick={() => hasAccess && handleNavigation(action.path)}
              >
                <CardContent style={{ textAlign: 'center' }}>
                  <div style={{ color: action.color, fontSize: '40px', marginBottom: '10px' }}>
                    {action.icon}
                  </div>
                  <Typography variant="h6" component="div">
                    {action.label}
                  </Typography>
                  {!hasAccess && (
                    <Typography variant="caption" color="textSecondary">
                      No access
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {/* Info Card */}
      <Card style={{ marginTop: '40px', backgroundColor: '#f5f5f5' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Information
          </Typography>
          <Typography variant="body2">
            Current Role: <strong>{user?.role}</strong>
          </Typography>
          <Typography variant="body2">
            Email: <strong>{user?.email}</strong>
          </Typography>
          <Typography variant="body2" style={{ marginTop: '10px' }}>
            Click on the cards above to navigate to different sections.
            <br />
            <strong>Viewer:</strong> Can access Transactions and Reports only
            <br />
            <strong>Manager:</strong> Can access Transactions, Reports, Settings
            <br />
            <strong>Admin:</strong> Can access all sections
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
}

export default Dashboard;